var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer"},[_c('div',{staticClass:"offer__descWrapper"},[_c('div',{staticClass:"offer__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"offer__desc"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }